import PredefinedConfiguration from './predefinedconfiguration'

export default PredefinedConfiguration